/// <amd-module name="Reporting/BurndownReport/BurndownReportPage" />
import * as React from "react";
import { extractParameter, getReportPageState, ReportState } from "Reporting/BoardsCommon/ReportPageState";
import { BurndownReport } from "Reporting/BurndownReport/BurndownReport";
import { IVssComponentProperties, VssComponent } from "VSS/Platform/Layout";

export interface IterationReportState extends ReportState {
    iterationPath: string;
    iterationStartDate: Date;
    iterationEndDate: Date;
}

/** New Platform page for standalone testing of Burndown Report. Has no hardening for input validation. */
export class BurndownReportPage extends VssComponent<IVssComponentProperties, IterationReportState> {
    public async componentDidMount(): Promise<void> {
        const fakeDate = new Date(); // Fake date info. For page UI testing, as opposed to perf scenarios we'd want to pull the real info from AX.
        this.setState({
            ...(await getReportPageState(this.context.pageContext)),
            iterationPath: extractParameter(this.context.pageContext, "iterationPath")!,
            iterationEndDate: fakeDate,
            iterationStartDate: fakeDate
        });
    }

    public render(): JSX.Element | null {
        if (this.state == null) {
            return null;
        }
        return (
            <BurndownReport
                iterationPath={this.state.iterationPath}
                iterationStartDate={this.state.iterationStartDate}
                iterationEndDate={this.state.iterationEndDate}
                teamId={this.state.teamId}
                teamName={this.state.teamName}
                projectId={this.state.projectId}
            />
        );
    }
}
VssComponent.register("BurndownReportPage", BurndownReportPage);
